var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"edit-module-authors"},[_c(_setup.EditAuthors,{attrs:{"add-author":_setup.onAuthorSelected,"author-subtext":String(_vm.$t("editor.editAuthorsSubtext")),"author-text":String(_vm.$t("editor.moduleAuthors")),"authors":_vm.authors,"remove-author":_setup.removeAuthor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }